<template>
<div>
  <b-button squared
        @click="showAlertMailModal()"
        class="alert-btn d-flex w-100 mb-3 mt-2"
        variant="outline-secondary">
      <div class="d-inline ml-4 mr-3 my-auto">
        <PictoAlert></PictoAlert>
      </div>
      Créer une alerte
      <div class="d-inline ml-auto mr-5 my-auto">
        <PictoArrow orientation="droite"></PictoArrow>
      </div>
  </b-button>
  <b-modal hide-footer
        centered
        id="alertMailModal">
    <template #modal-title>
      <span class="text-secondary font-weight-bold mx-auto">Créer une alerte</span>
    </template>
    <div>
      <p v-if="formSent">La demande a bien été envoyée</p>
      <p v-if="error">{{ error }}</p>
      <form>
        <i>Recevez un mail à chaque nouvelle annonce correspondant a votre recherche</i>
        <div v-if="request">
          <strong>Votre recherche :</strong>
          <ul>
            <li v-if="request.type.length">Type: {{ request.type }}</li>
            <li v-if="request.nbrPieces.length">Nombre de pièces: {{ request.nbrPieces }}</li>
            <li v-if="request.city">Ville: {{ request.city }}</li>
            <li v-if="request.surface">Surface: {{ request.surface }}</li>
            <li v-if="request.rayon">Rayon: {{ request.rayon }}</li>
            <li v-if="request.budget">Budget: {{ request.budget }}</li>
          </ul>
        </div>
        
        <input type="email" class="form-control" id="emailInput" v-model="email" placeholder="Email">
        <input 
          type="submit" 
          class="btn btn-secondary m-3" @click.prevent="sendEmailToAlert()" value="Envoyer" squared>
      </form>
    </div>
  </b-modal>
</div>
</template>

<script>
import DataApi from '../dependencies/index'

export default {
  name: 'BienAlertEmail',
  components: {
    PictoAlert: () => import('./PictoAlert'),
    PictoArrow: () => import('./PictoArrow')
  },
  props: {
    bien: Object
  },
  data: function () {
    return {
      email: '',
      error: null,
      formSent: null,
      request: null
    }
  },
  methods: {
    showAlertMailModal () {
      console.log(this.bien)
      this.request = {
        city: this.bien.cityNames,
        type: this.bien.type,
        nbrPieces: this.bien.nbrPieces,
        surface: (this.bien.surface.toString().split(',').join('-') + ' m²'),
        rayon: this.bien.rayon + ' km',
        budget: (this.bien.budget.toString().split(',').join('-') + ' €')
      }
      this.$bvModal.show('alertMailModal')
    },
    async sendEmailToAlert () {
      if (document.getElementById('emailInput').reportValidity()) {
        const options = {
          apiUrl: this.$apiUrl,
          databaseName: this.$databaseName,
          token: await this.$getMainToken()
        }
        const request = 'type: ' + this.bien.type +
          ' nbrPieces: ' + this.bien.nbrPieces +
          ' surface: ' + this.bien.surface +
          ' rayon: ' + this.bien.rayon +
          ' budget: ' + this.bien.budget
        const demandeToSend = {
          email: this.email,
          telephone: '',
          adresse: '',
          codePostal: '',
          ville: '',
          pays: '',
          questions: request,
          rgpd: '',
          type: 'alerte',
          destinataire: 'ti'
        }
        const dataApi = new DataApi(options)
        dataApi.createRecord('W_DemandeContact', demandeToSend, 
          [{
            name: 'validerFormulaire',
            type: 'postrequest'
          }])
          .then((response) => {
            this.formSent = true
            setTimeout(() => {
              this.formSent = false
              this.$bvModal.hide('alertMailModal')
            }, 3000)
          })
          .catch((error) => {
            console.log(error)
            this.error = 'La demande n\'a pas pu être enregistrée, veuillez reéssayer plus tard'
            setTimeout(() => {
              this.error = null
              this.$bvModal.hide('alertMailModal')
            }, 3000)
          })
      }
      this.email = null
    }
  }
}
</script>

<style lang="scss">
button {
  .pictoArrow {
    fill: var(--secondary);
    height: 0.65rem;
  }
  .pictoAlert {
    stroke: var(--secondary);
  }
}
button:hover {
  .pictoArrow {
    fill: var(--light);
  }
  .pictoAlert {
    stroke: var(--light);
  }
}
</style>
